import { Stack, Typography } from '@mui/material';

import { SummaryCardNew } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import SignatureImg from '@assets/images/signature_discount_letter.png';

import type { FinancialIncomeReportCardProps } from './types';
import { IncomeReportCardItem, IncomeReportTable } from './components';
import { columns } from './constants/columns';
import { StyledContainer } from './styles';

export function FinancialIncomeReportCard({
  responsible,
  recipient,
  extracts,
  total,
  isPrint = false,
}: Readonly<FinancialIncomeReportCardProps>) {
  return (
    <StyledContainer marginTop={3} isPrint={isPrint}>
      <SummaryCardNew.Container gap={1}>
        <Typography variant="subtitle1" fontWeight={900}>
          Fonte responsável
        </Typography>

        <Stack
          flexDirection="row"
          justifyContent="space-between"
          flexWrap="wrap"
        >
          <IncomeReportCardItem title="Razão Social" value={responsible.name} />
          <IncomeReportCardItem title="CNPJ" value={responsible.document} />
          <IncomeReportCardItem title="Endereço" value={responsible.address} />
          <IncomeReportCardItem
            title="Código contrato"
            value={responsible.code}
          />
        </Stack>

        <Typography variant="subtitle1" fontWeight={900} mt={2}>
          Fonte recebedora
        </Typography>
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          flexWrap="wrap"
        >
          <IncomeReportCardItem title="Razão Social" value={recipient.name} />
          <IncomeReportCardItem title="CNPJ" value={recipient.document} />
          <IncomeReportCardItem title="Endereço" value={recipient.address} />
        </Stack>

        <Typography variant="subtitle1" fontWeight={900} mt={isPrint ? 0 : 3}>
          Extrato
        </Typography>

        <IncomeReportTable columns={columns} extract={extracts} total={total} />
      </SummaryCardNew.Container>
      {isPrint && (
        <>
          <Stack p={3}>
            <Typography
              variant="text"
              color={NEW_COLORS.BASE.BLACK}
              fontWeight={600}
            >
              Atenciosamente,
            </Typography>
            <Stack maxHeight={230} maxWidth={230}>
              <img src={SignatureImg} alt="HAPVIDA" />
            </Stack>
            <Typography
              variant="text"
              width="100%"
              color={NEW_COLORS.BASE.BLACK}
              fontWeight={600}
            >
              (assinatura do(a) gerente Ndi Saúde)
            </Typography>
          </Stack>
        </>
      )}
    </StyledContainer>
  );
}
